<div class="metric-cell">
  <span>{{ value }}</span>
  @if (tooltip) {
    <app-tooltip-icon [text]="tooltip" place="above" />
  }
</div>
